import { useState } from 'react'
import { createAttachmentUploads } from './createAttachmentUploads'
import { useAiAskBarAttachmentActions } from './useAiAskBarAttachmentActions'
import { useAiAskBarDictationActions } from './useAiAskBarDictationActions'
import { useAiAskBarSendActions } from './useAiAskBarSendActions'
import { useComposerChatSession } from './useComposerChatSession'

/**
 * @param {object} p
 * @param {ReturnType<typeof import('./useAiAskBarModel').useAiAskBarModel>} p.model
 */
export function useAiAskBarActions({ model, onSend, sendDisabled, onDictationSessionEnd, selectedModel, ensureChatId }) {
  // One registry per composer: a send must wait only on its own uploads.
  const [uploads] = useState(createAttachmentUploads)
  // Shared: uploads resolve the chat, send hands the provisional one over.
  const chat = useComposerChatSession(ensureChatId)

  const send = useAiAskBarSendActions({
    onSend,
    sendDisabled,
    isDictating: model.isDictating,
    composerEditorRef: model.composerEditorRef,
    connectContextRef: model.connectContextRef,
    attachmentsRef: model.attachmentsRef,
    setComposerPlainText: model.setComposerPlainText,
    setAttachments: model.setAttachments,
    uploads,
    chat,
    model: selectedModel,
    refinement: model.refinement,
    clearRefinement: model.clearRefinement,
  })
  const attachments = useAiAskBarAttachmentActions({
    attachments: model.attachments,
    attachmentsRef: model.attachmentsRef,
    fileInputRef: model.fileInputRef,
    setAttachments: model.setAttachments,
    setDocumentsPickerOpen: model.setDocumentsPickerOpen,
    revokePreviewUrls: model.revokePreviewUrls,
    uploads,
    chat,
  })
  const dictation = useAiAskBarDictationActions({
    finalizeSession: model.finalizeSession,
    onDictationSessionEnd,
    setIsDictating: model.setIsDictating,
  })

  return { ...send, ...attachments, ...dictation }
}
